import { render } from "./MainLayout.vue?vue&type=template&id=70527e12"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=70527e12&lang=scss"
script.render = render

export default script